var exports = {
  "X": "xa15a2ab7--1cbc66--modal-content-fallback",
};

module.exports = exports;
